import React, { useMemo, useEffect } from 'react';
import provideActivityLink from '@/components/provide-activity-link';
import utils from '@/common/utils';
import { Modal } from 'antd';
import Microapp from '@/components/micro-app';
import useBabelTowerDevBranch from '@/hooks/useBabelTowerDevBranch';
import ENV from '@/env';

function useInjectedLink() {
  const {
    toTiBaoVenueCreate,
    toTiBaoVenueEdit,
    toTiBaoQuaSetting,
    toTiBaoVenueSetting,
  } = provideActivityLink.useActivityLink();

  const dataInToMicroApp = {
    // 创建收品池
    gotoCreatePool(extPathname = '', otherWindow) {
      if (typeof extPathname === 'function') extPathname = extPathname();

      otherWindow.location.href = toTiBaoVenueCreate(extPathname).get();
    },
    // 设置收品池
    gotoSetPool(extPathname = '', otherWindow) {
      if (typeof extPathname === 'function') extPathname = extPathname();

      otherWindow.location.href = toTiBaoVenueEdit(extPathname).get();
    },
    // 去到资质设置
    gotoQualiSetting(extPathname = '', otherWindow) {
      if (typeof extPathname === 'function') extPathname = extPathname();

      otherWindow.location.href = toTiBaoQuaSetting(extPathname).get();
    },
    gotoChangCiSetting(extPathname = '', otherWindow) {
      if (typeof extPathname === 'function') extPathname = extPathname();

      otherWindow.location.href = toTiBaoVenueSetting(extPathname).get();
    },
  };

  return dataInToMicroApp;
}

function BabelPage() {
  const breadcrumbs = useMemo(function () {
    let roadpath = [];
    try {
      roadpath = JSON.parse(utils.getQuery('breadcrumbs')) || [];
    } catch (ex) {
      console.error(ex);
    }

    return roadpath;
  }, []);

  const url = useBabelTowerDevBranch(ENV.BABEL_DOMAIN + '/active/babelTower/index.html');

  const dataInToMicroApp = useInjectedLink();

  useEffect(() => {
    const oldOnbefοreunlοadacore = window.οnbefοreunlοadacore;
    // 替换掉老的回调函数
    window.οnbefοreunlοadacore = function (continueGoTo) {
      Modal.confirm({
        title: '确认要离开此页面？',
        content: <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>请先保存当前内容，直接离开您未保存的内容将会丢失</span>,
        onOk: continueGoTo,
      });
    };

    // 目的：兼容通天塔内嵌的玲珑平台和通天塔通过方法successMakeMotion完成交互
    // 玲珑通过iframe嵌入到通天塔页面，并通过window.parent.successmakeMotion获取到通天塔注入window的方法
    // 因为通天塔JS运行在microapp的沙盒内，获取不到顶层的window又window.parent获取到的是当前窗口的window
    // 所以我们需要手动作一层方法的转发，将当前window.successmakeMotion方法转发到window.proxyWdindow.successmakeMotion中

    // 如果通天塔和玲珑通信的方法名称(successMakeMotion)未通知活动中心的情况下作了修改那么这个转发将会失效
    const oldSuccessMakeMotion = window.successMakeMotion;

    window.successMakeMotion = function (...args) {
      try {
        if (typeof oldSuccessMakeMotion === 'function') oldSuccessMakeMotion.apply(window, args);
      } catch (ex) {
        console.error(ex);
      }

      try {
        if (window.proxyWindow && typeof window.proxyWindow.successMakeMotion === 'function')
          window.proxyWindow.successMakeMotion.apply(window.proxyWindow, args);
        else {
          console.error('window.proxyWindow && typeof window.proxyWindow.successMakeMotion 为 false');
        }
      } catch (ex) {
        console.error(ex);
      }
    };

    return () => {
      window.οnbefοreunlοadacore = oldOnbefοreunlοadacore;
      window.successMakeMotion = oldSuccessMakeMotion;
    };
  });

  return (
    <Microapp
      data={{
        basename: '/materials/babel',
        breadcrumbs,
        findLinkToTBCollectProduct(query = '') {
          return '/activity-manage/detail/act-manage/act-room/page' + query;
        },
        ...dataInToMicroApp,
      }}
      url={url}
      name="babeldemo"
    />
  );
}

export default (props) => {
  const findThemeActivityTypeByQuery = provideActivityLink.themeActivityType.findThemeActivityTypeByQuery(
    window.location.query
  );

  if (findThemeActivityTypeByQuery.isChannel()) {
    return (
      <provideActivityLink.channel>
        <BabelPage {...props} />
      </provideActivityLink.channel>
    );
  } else {
    return (
      <provideActivityLink.activitymanage>
        <BabelPage {...props} />
      </provideActivityLink.activitymanage>
    );
  }
};
